import { Skeleton, styled } from "@mui/material";
import { HTMLAttributes } from "react";

const CategorySkeleton = (props: HTMLAttributes<HTMLDivElement>) => {
  return (
    <StyledChipSkeleton {...props}>
      <Skeleton variant="circular" height={100} width={100} />
      <Skeleton variant="text" height={20} width={96} className="cate-name" />
      <Skeleton
        variant="text"
        height={20}
        width={48}
        className="cate-name"
        sx={{ mx: "auto" }}
      />
    </StyledChipSkeleton>
  );
};

const StyledChipSkeleton = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  ".cate-name": {
    marginTop: 8,
  },
});

export default CategorySkeleton;
